// Hero tabs: switches between the hero blocks in a tabbed hero section.
//
// Panels are stacked in one CSS grid cell and the inactive ones are hidden with
// visibility, not display — so the section keeps the height of its tallest panel
// and switching tabs never shifts the page. visibility:hidden also drops the
// inactive panel out of the tab order and the accessibility tree, so the hidden
// hero's CTA can't be focused.
//
// Delegated on document and guarded by an init flag, so it survives the theme
// editor re-rendering a section without double-binding.
(function () {
  if (window.__heroTabsInit) return;
  window.__heroTabsInit = true;

  function panelsFor(hero) {
    return Array.prototype.slice.call(hero.querySelectorAll("[data-hero-panel]"));
  }

  function tabsFor(hero) {
    return Array.prototype.slice.call(hero.querySelectorAll("[data-hero-tab]"));
  }

  function activate(hero, blockId, moveFocus) {
    if (!hero || !blockId) return;

    panelsFor(hero).forEach(function (panel, i) {
      var on = panel.getAttribute("data-hero-panel") === blockId;
      panel.classList.toggle("hero__panel--active", on);
      // aria-hidden mirrors the visibility the stylesheet applies, so assistive
      // tech and the CSS never disagree about which hero is showing.
      panel.setAttribute("aria-hidden", on ? "false" : "true");
      // The slide itself is pure CSS — this only says which panel to stop on.
      if (on) hero.style.setProperty("--hero-index", i);
    });

    tabsFor(hero).forEach(function (tab) {
      var on = tab.getAttribute("data-hero-tab") === blockId;
      tab.setAttribute("aria-selected", on ? "true" : "false");
      // Roving tabindex: only the selected tab is a tab stop, arrows move between.
      tab.setAttribute("tabindex", on ? "0" : "-1");
      if (on && moveFocus) tab.focus();
    });
  }

  document.addEventListener("click", function (e) {
    var tab = e.target.closest("[data-hero-tab]");
    if (!tab) return;
    e.preventDefault();
    activate(tab.closest("[data-hero]"), tab.getAttribute("data-hero-tab"), false);
  });

  // Left/Right arrows move between tabs, per the tablist pattern.
  document.addEventListener("keydown", function (e) {
    if (e.key !== "ArrowRight" && e.key !== "ArrowLeft") return;
    var tab = e.target.closest("[data-hero-tab]");
    if (!tab) return;
    var hero = tab.closest("[data-hero]");
    var tabs = tabsFor(hero);
    var i = tabs.indexOf(tab);
    if (i === -1) return;
    e.preventDefault();
    var next = tabs[(i + (e.key === "ArrowRight" ? 1 : -1) + tabs.length) % tabs.length];
    activate(hero, next.getAttribute("data-hero-tab"), true);
  });

  // Theme editor: selecting a hero block should bring that hero to the front,
  // otherwise the merchant edits a panel they can't see.
  document.addEventListener("shopify:block:select", function (e) {
    var panel = e.target.closest
      ? e.target.closest("[data-hero-panel]") || e.target.querySelector("[data-hero-panel]")
      : null;
    var hero = e.target.closest ? e.target.closest("[data-hero]") : null;
    if (!hero && panel) hero = panel.closest("[data-hero]");
    if (!hero) return;
    var id = panel ? panel.getAttribute("data-hero-panel") : null;
    if (id) activate(hero, id, false);
  });
})();
